import * as React from 'react';
import glamorous from 'glamorous';
import gql from 'graphql-tag';
import { RvLoader } from '../../components/Loader';
import { Query } from 'react-apollo';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber, getHighestNumberInArray, getMaxSuggestedTick } from '../../helpers/ChartHelper';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState, FooterDescription, HelpWrapper } from '../Common';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { DrillDownType } from '../DrillDownType';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';
import MTooltip from '@material-ui/core/Tooltip';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import { VideoModal } from '../../components/VideoModal';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartStatTiles } from '../ChartStatTiles';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
    '@media print': {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'center',
    },
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {},
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
    [`& .${`h3`}`]: {
        paddingTop: '10px',
    },
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        },
    },
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

interface ChartProps extends ChartCommonProps, WithStyles<typeof styles> {
    getSelectedItem?: (searchCriterias: Array<SearchCriteria>, isShowCompleted: boolean, title?: string, drillDownType?: DrillDownType, defaultView?: string) => void;
    chartFilter?: ChartFilter;
    infoUrl: string | null;
}

const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingRight: 5,
}));

interface ChartState extends ChartCommonState {
    isVideoModalOpen: boolean;
}

class MatterFeesVsEstimate extends React.Component<ChartProps, ChartState> {
    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.onHover = this.onHover.bind(this);
        this.onToggleVideo = this.onToggleVideo.bind(this);

        this.onPan = this.onPan.bind(this);

        this.chartRef = React.createRef();

        this.state = {
            open: false,
            anchorEl: undefined,
            isVideoModalOpen: false
        };
    }

    public componentDidMount() {
        //
    }

    public componentWillUnmount() {
        //
    }

    public shouldComponentUpdate(nextProps: ChartProps, nextState: ChartState): boolean {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }

        return false;
    }

    public render() {
        // const { classes } = this.props;
        var symbol = '';
        return (
            <React.Fragment>
                {this.state.isVideoModalOpen && this.props.infoUrl && (
                    <VideoModal 
                        open={this.state.isVideoModalOpen}
                        onClose={this.onToggleVideo}
                        url={this.props.infoUrl}
                    />
                )}
                {/* tslint:disable-next-line: no-any */}
                <Query<any> query={CurrencySymbol}>
                    {(result) => {
                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="bars" />
                            );
                        }

                        const currencySymbol = result.loading || result.error ? null : result.data.options.currencySymbol;

                        symbol = currencySymbol ? currencySymbol.symbol : null;
                        return (
                            // tslint:disable-next-line: no-any
                            <Query<any>
                                query={MatterFeesVsEstimateData}
                                variables={{
                                    entityType: this.props.chartFilter?.entityType,
                                    entityGuid: this.props.chartFilter?.entityGuid,
                                    responsibility: this.props.chartFilter?.responsibility,
                                }}
                            >
                                {({ loading, error, data }) => {
                                    if (loading) {
                                        return (
                                            <LoadWrapper className="load-wrapper">
                                                <RvLoader size="small" />
                                            </LoadWrapper>
                                        );
                                    }

                                    const statistics = data.statistics;

                                    let matter = loading || error || statistics === null || statistics === undefined ? null : statistics.matter;

                                    let matterFeesVsEstimate = matter ? matter.matterFeesVsEstimate : null;

                                    if (matterFeesVsEstimate) {
                                        const {
                                            mattersWithNoEstimateBilledFee,
                                            mattersWithNoEstimateUnBilledFee,
                                            mattersCount,
                                            mattersWithNoEstimate,
                                            exceedingHundred,
                                            exceedingEightyFive,
                                            exceedingSixty,
                                            lessThanSixty,
                                        } = matterFeesVsEstimate;

                                        return (
                                            <BarWrapper className={RV_CHART_CLASS}>
                                                <IconButtonWrapper aria-label="close">
                                                    <HelpWrapper className="rv-chart-help">
                                                        <ChartInfo 
                                                            description={this.props.description}
                                                        />
                                                        {this.props.infoUrl && (
                                                            <MTooltip title="Learn more">
                                                                <IconButton
                                                                    style={{ color: 'rgb(0, 120, 212)' }}
                                                                    aria-label="maximize"
                                                                    onClick={this.onToggleVideo}
                                                                    size={this.props.showAllRecords ? 'medium' : 'small'}
                                                                >
                                                                    <VideoLibraryOutlinedIcon />
                                                                </IconButton>
                                                            </MTooltip>
                                                        )}
                                                    </HelpWrapper>
                                                    <IconButton aria-label="close" onClick={this.onCloseChart} size="small">
                                                        <CloseIcon />
                                                    </IconButton>
                                                </IconButtonWrapper>
                                                <BarTitleContainer>
                                                    <ChartHeading icon={<AssessmentOutlinedIcon />} title="Fees vs Estimate" />
                                                    <TotalDiv className="h2" onClick={() => this.handleTotalClick()}>
                                                        <AnimatedNumber value={mattersCount} format={(amount) => formatNumber(amount)} />
                                                    </TotalDiv>
                                                    <div className="h3">Current Matters with Estimates</div>
                                                </BarTitleContainer>
                                                <BarContainer className="rv-chart-bars">
                                                    <Bar
                                                        ref={this.chartRef}
                                                        // tslint:disable-next-line: no-any
                                                        onClick={(event: React.MouseEvent<any>) => {
                                                            const _data = getElementAtEvent(this.chartRef.current, event);
                                                            if (_data.length > 0 && this.props.getSelectedItem) {
                                                                const _index = getElementAtEvent(this.chartRef.current, event)[0].index;

                                                                const item = ['Exceeding 100%', 'Exceeding 85%', 'Exceeding 60%', 'Less Than 60%'][_index];

                                                                const searchCriterias = new Array<SearchCriteria>();

                                                                // TODO: This is Changed/ New Fix this
                                                                if (item === 'Exceeding 100%') {
                                                                    searchCriterias.push({ property: 'FeeVsEstimate', operator: 'gt', comparison: '100' });
                                                                } else if (item === 'Exceeding 85%') {
                                                                    searchCriterias.push(
                                                                        { property: 'FeeVsEstimate', operator: 'gt', comparison: '85' },
                                                                        { property: 'FeeVsEstimate', operator: 'lteq', comparison: '100' },
                                                                    );
                                                                } else if (item === 'Exceeding 60%') {
                                                                    searchCriterias.push(
                                                                        { property: 'FeeVsEstimate', operator: 'gt', comparison: '60' },
                                                                        { property: 'FeeVsEstimate', operator: 'lteq', comparison: '85' },
                                                                    );
                                                                } else {
                                                                    searchCriterias.push({ property: 'FeeVsEstimate', operator: 'lt', comparison: '60' });
                                                                }

                                                                this.props.getSelectedItem(
                                                                    searchCriterias,
                                                                    false,
                                                                    'Fees vs Estimate',
                                                                    DrillDownType.matterSummaryDrilldown,
                                                                    'matters',
                                                                );
                                                            }
                                                        }}
                                                        data={{
                                                            labels: ['Exceeding 100%', 'Exceeding 85%', 'Exceeding 60%', 'Less Than 60%'],
                                                            datasets: [
                                                                {
                                                                    label: 'Matters',
                                                                    ...rvBarDatasetStyle([RV_CHART_COLORS.red, RV_CHART_COLORS.amber, RV_CHART_COLORS.primary, RV_CHART_COLORS.primarySoft]),
                                                                    data: [exceedingHundred, exceedingEightyFive, exceedingSixty, lessThanSixty],
                                                                },
                                                            ],
                                                        }}
                                                        options={{
                                                            onHover: this.onHover,
                                                            indexAxis: 'y' as const,
                                                            animation: rvChartAnimation(),
                                                            elements: { bar: { borderWidth: 0 } },
                                                            responsive: true,
                                                            maintainAspectRatio: false,
                                                            scales: {
                                                                x: {
                                                                    grid: rvValueAxisStyle.grid,
                                                                    // beginAtZero: true,
                                                                    suggestedMax: getMaxSuggestedTick(
                                                                        getHighestNumberInArray([exceedingHundred, exceedingEightyFive, exceedingSixty, lessThanSixty]),
                                                                        6,
                                                                    ),
                                                                    beginAtZero: true,
                                                                    ticks: {
                                                                        ...rvValueAxisStyle.ticks,
                                                                        autoSkip: false,
                                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                            return `${formatNumber(tickValue)}`;
                                                                        },
                                                                    },
                                                                },
                                                                y: {
                                                                    grid: rvCategoryAxisStyle.grid,
                                                                    // min: 0,
                                                                    // max: 9 // minimum display
                                                                    ticks: {
                                                                        ...rvCategoryAxisStyle.ticks,
                                                                        autoSkip: false
                                                                    }
                                                                }
                                                            },
                                                            plugins: {
                                                                legend: {
                                                                    position: 'bottom' as const,
                                                                    display: false,
                                                                },
                                                                title: {
                                                                    display: false,
                                                                    text: `Fees + WIP vs Estimate`,
                                                                },
                                                                zoom: {
                                                                    pan: {
                                                                        enabled: false,
                                                                        onPan: this.onPan,
                                                                    },
                                                                    zoom: {
                                                                        wheel: {
                                                                            enabled: false,
                                                                        },
                                                                    },
                                                                    // limits: {
                                                                    //   y: { min: 0, max: 9 },
                                                                    // },
                                                                },
                                                                tooltip: {
                                                                    ...rvTooltipStyle,
                                                                    callbacks: {
                                                                        // tslint:disable-next-line: no-any
                                                                        label: function (context: any) {
                                                                            const {
                                                                                //   dataIndex,
                                                                                //   label,
                                                                                formattedValue,
                                                                                dataset,
                                                                            } = context;

                                                                            return `${dataset.label} ${formattedValue}`;
                                                                        },
                                                                    },
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    {isChartDataEmpty([exceedingHundred, exceedingEightyFive, exceedingSixty, lessThanSixty]) && (
                                                        <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                                                    )}
                                                </BarContainer>
                                                <FooterDescription>
                                                    <ChartStatTiles
                                                        caption="Matters with no estimate"
                                                        tiles={[
                                                            { label: 'Matters', value: formatNumber(mattersWithNoEstimate), color: RV_CHART_COLORS.amber, onClick: () => this.handleNoEstimates() },
                                                            { label: 'Billed fees', value: `${symbol}${formatNumber(mattersWithNoEstimateBilledFee)}`, color: RV_CHART_COLORS.green },
                                                            { label: 'WIP', value: `${symbol}${formatNumber(mattersWithNoEstimateUnBilledFee)}` },
                                                        ]}
                                                    />
                                                    <ChartNotes notes={['Fees only, disbursements are not included']} />
                                                </FooterDescription>
                                            </BarWrapper>
                                        );
                                    }

                                    return (
                                        <LoadWrapper className="load-wrapper">
                                            <RvLoader size="small" />
                                        </LoadWrapper>
                                    );
                                }}
                            </Query>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }

    private handleTotalClick() {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: 'EstimatedCosts', operator: 'gt', comparison: '0' });

            this.props.getSelectedItem(searchCriterias, false, 'Fees vs Estimate', DrillDownType.matterSummaryDrilldown, 'matters');
        }
    }

    private handleNoEstimates() {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'NoEstimatedCosts', operator: 'eq', comparison: '0' });

            this.props.getSelectedItem(searchCriterias, false, 'Fees vs Estimate', DrillDownType.matterSummaryDrilldown, 'Matters');
        }
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart('isMatterFeesVsEstimateChartOpen');
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue),
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.x.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }

    private onToggleVideo() {
        this.setState({
            isVideoModalOpen: !this.state.isVideoModalOpen
        });
    }
}

// tslint:disable-next-line: no-any
export default withStyles(styles as any, { withTheme: true })(MatterFeesVsEstimate as any) as any;

const MatterFeesVsEstimateData = gql`
    query MatterFeesVsEstimateData($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                matterFeesVsEstimate(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    mattersWithNoEstimateBilledFee
                    mattersWithNoEstimateUnBilledFee
                    mattersCount
                    mattersWithNoEstimate
                    exceedingHundred
                    exceedingEightyFive
                    exceedingSixty
                    lessThanSixty
                }
            }
        }
    }
`;

const CurrencySymbol = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;
